/**
 * Composable pour gérer l'URL de l'API
 * Utilise automatiquement l'URL locale en développement et Heroku en production
 */
export function useApi() {
  const API_URL = 'https://bookmysalon-967a856b16b6.herokuapp.com'

  /**
   * Construit l'URL complète pour un endpoint
   * @param {string} endpoint - L'endpoint (ex: '/api/clients/login')
   * @returns {string} L'URL complète
   */
  const getUrl = (endpoint) => {
    // Enlever le slash initial si présent pour éviter les doubles slashes
    const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`
    return `${API_URL}${cleanEndpoint}`
  }

  /**
   * Effectue une requête fetch avec l'URL de l'API
   * @param {string} endpoint - L'endpoint
   * @param {object} options - Options fetch
   * @returns {Promise} La promesse fetch
   */
  const fetchApi = (endpoint, options = {}) => {
    return fetch(getUrl(endpoint), options)
  }

  return {
    API_URL,
    getUrl,
    fetchApi
  }
}
